import axios from "axios";
import { epochInSeconds } from "@common/components/helpers/datetime";

class ApiClient {
  constructor(name) {
    this.name = name;
    this.apiUrlKey = "base_url";
    this.setupAxios();
  }

  setApiUrlKey(urlKey) {
    this.apiUrlKey = urlKey;
  }

  setupAxios = () => {
    this.axios = axios.create();
    this.registerInterceptors();
  };

  complianceWillExpire = () => {
    const expiry = sessionStorage.getItem("tokenExpires");
    const now = epochInSeconds();

    if (!expiry) {
      return true;
    }
    return expiry < now;
  };

  registerInterceptors = () => {
    // Append session token to header
    this.axios.interceptors.request.use(async (config) => {
      const token = sessionStorage.getItem("token");
      const deviceId = sessionStorage.getItem("deviceId");
      const accessToken = sessionStorage.getItem("accessToken");
      const refreshToken = sessionStorage.getItem("refreshToken");

      const refreshTokenConditions = [
        token,
        refreshToken,
        this.complianceWillExpire(),
        !config.url.includes("RefreshToken"),
        !config.url.includes("/Authentication/SignIn"),
      ];

      if (refreshTokenConditions.every((condition) => condition)) {
        this.axios
          .request({
            url: `${sessionStorage.getItem(
              "auth_api_url",
            )}/Authentication/RefreshToken`,
            method: "POST",
            data: { refreshToken },
          })
          .then(({ accessToken, refreshToken, expiresIn }) => {
            sessionStorage.setItem("accessToken", accessToken);
            sessionStorage.setItem("refreshToken", refreshToken);
            sessionStorage.setItem(
              "tokenExpires",
              epochInSeconds() + expiresIn,
            );
          });
      }

      // Fake delay to test loading indicators in development mode
      // await delay(3000);

      return {
        ...config,
        headers: {
          common: {
            SessionKey: token,
            DeviceKey: deviceId,
          },
          // For Compliance API
          Authorization: `Bearer ${accessToken}`,
        },
      };
    });
  };

  request = async (endpoint, method, data = {}, options = {}) => {
    const url = `${sessionStorage.getItem(
      this.apiUrlKey,
    )}/${this.name}/${endpoint}`;
    return await this.axios.request({
      url,
      method,
      data,
      ...options,
    });
  };

  get = async (endpoint) => {
    const response = await this.request(endpoint, "GET");
    return response.data;
  };

  put = async (endpoint, payload = {}) => {
    const response = await this.request(endpoint, "PUT", payload);
    return response.data;
  };

  post = async (endpoint, payload = {}, options = {}) => {
    const response = await this.request(endpoint, "POST", payload, options);
    return response.data;
  };

  getFile = async (endpoint, verb = "GET", payload = {}) => {
    const response = await this.request(endpoint, verb, payload, {
      responseType: "arrayBuffer",
    });
    return response;
  };

  CheckSuspended = async () => {
    return await this.get("security/setup/config");
  };
}

export default ApiClient;
